module.exports = __webpack_public_path__ + "img/404.049a1263.svg";